export const COMMISSION_LIST_REQUEST   = 'COMMISSION_LIST_REQUEST'
export const COMMISSION_GET_REQUEST    = 'COMMISSION_GET_REQUEST'
export const COMMISSION_CREATE_REQUEST = 'COMMISSION_CREATE_REQUEST'
export const COMMISSION_UPDATE_REQUEST = 'COMMISSION_UPDATE_REQUEST'
export const COMMISSION_DELETE_REQUEST = 'COMMISSION_DELETE_REQUEST'

export const COMMISSION_PEOPLES_REQUEST = 'COMMISSION_PEOPLES_REQUEST'

export const COMMISSION_MEMBERS_REQUEST       = 'COMMISSION_MEMBERS_REQUEST'
export const COMMISSION_MEMBER_ADD_REQUEST    = 'COMMISSION_MEMBER_ADD_REQUEST'
export const COMMISSION_MEMBER_UPDATE_REQUEST    = 'COMMISSION_MEMBER_UPDATE_REQUEST'
export const COMMISSION_MEMBER_DELETE_REQUEST = 'COMMISSION_MEMBER_DELETE_REQUEST'
